<template lang="pug">
  v-container
    institution-export(:institution-id="user.institution.id")
</template>
<script>
import { mapState } from 'vuex';
import InstitutionExport from '@/components/InstitutionExport';

export default {
  components: { InstitutionExport },
  computed: {
    ...mapState({
      user: s => s.auth.user
    })
  }
};
</script>
